export function formatAmount(amt: number) {
	return amt?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
